<template>
  <div style="flex: 1">
    <div class="funnel-filter">
      <div class="form-group">
        <select
          id="select-employer-chart-one"
          class="form-control"
          v-model="selectedEmployer"
          @change="fetchJobsForSelectedEmployer"
        >
          <option
            :value="{
              name: 'Employer',
              address: { address: '', postal_code: '' },
              city: {
                country_id: null,
                id: null,
                latitude: '',
                longitude: '',
                name: '',
              },
              country: { id: null, name: '', part_of_eu: null, phone_code: '', source: '' },
              id: '',
              is_default: false,
            }"
          >
            Employer
          </option>
          <option v-for="employer in getEmployersDropdown" :key="employer.id" :value="employer">
            {{ employer.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <DropdownCheckbox
          v-model="jobFilterDataModel"
          :options="jobsForEmployerOptions"
          @input="handleJobFilter"
          name="chart-one"
          placeholder="Jobs"
          label="title"
        />
      </div>

      <div class="form-group">
        <!-- TIME RANGE -->
        <TimeRange
          name="chart-one-time-range"
          @input="handleTimeRangeFilter"
          v-model="timeRangeDataModel"
        />

        <!-- END TIME REANGE -->
      </div>
    </div>

    <LineChartJobs
      :key="key"
      :chartPropData="getChartOneData"
      v-if="getChartOneData.length"
      :style="myStyles"
    />

    <div class="spinner-container text-center" v-if="isLoading">
      <svgHelper v-show="isLoading" name="loadingSpinner" class="ml-auto justify-items-center" />
    </div>
  </div>
</template>

<script>
import LineChartJobs from '@/components/Admin/Dashboard/Charts/LineChart';
import { mapActions, mapGetters } from 'vuex';

import TimeRange from '@/components/common/TimeRange/TimeRange';
import DropdownCheckbox from '@/components/common/DropdownCheckbox/DropdownCheckbox';

import format from 'date-fns/format';

export default {
  name: 'ChartOne',
  components: {
    LineChartJobs,
    TimeRange,
    DropdownCheckbox,
  },
  data: () => ({
    timeRangeDataModel: { value: 'all_time', option: 'All time' },
    selectedEmployer: {
      name: 'Employer',
      address: { address: '', postal_code: '' },
      city: {
        country_id: null,
        id: null,
        latitude: '',
        longitude: '',
        name: '',
      },
      country: { id: null, name: '', part_of_eu: null, phone_code: '', source: '' },
      id: '',
      is_default: false,
    },
    startDate: '',
    endDate: '',
    jobsForEmployerOptions: [],
    isLoading: false,
    key: 0,
    myStyles: {
      position: 'relative',
      height: `${80}%`,
    },
    jobFilterDataModel: [],
  }),
  methods: {
    ...mapActions(['retrieveCharOnetData', 'retrieveJobsForEmployerDropdown']),
    handleJobFilter() {
      /*  console.log('input...'); */
      this.fetchCharOnetData(this.jobFilterDataModel, this.timeRangeDataModel.value);
    },
    handleTimeRangeFilter() {
      this.fetchCharOnetData(this.jobFilterDataModel, this.timeRangeDataModel.value);
    },
    fetchJobsForSelectedEmployer() {
      this.isLoading = true;

      // Remove previous graph
      this.retrieveCharOnetData({
        jobs_ids: [],
        date: ['all_time'],
      });

      if (this.selectedEmployer.name !== 'Employer') {
        this.retrieveJobsForEmployerDropdown({ employerId: this.selectedEmployer.id })
          .then(response => {
            this.jobsForEmployerOptions = response.data;
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        this.jobFilterDataModel = [];
        this.jobsForEmployerOptions = [];

        this.isLoading = false;
      }

      // Reset local storage and data vars TODO:
      this.localStoragePlugin.set('chartOneJobSelect', []);
      this.jobFilterDataModel = [];
      this.timeRangeDataModel = { value: 'all_time', option: 'All time' };
    },
    formatDates(startDate, endDate) {
      /*  if (startDate) {
        formattedDates = format(startDate, this.dateFormat);
      }

      if (endDate) {
        formattedDates += ' - ' + format(endDate, this.dateFormat);
      } */

      if (startDate && endDate) {
        return `${format(startDate, this.dateFormat)} - ${format(endDate, this.dateFormat)}`;
      }
    },
    fetchCharOnetData(listOfIds, timeRange) {
      this.isLoading = true;

      if (listOfIds.length) {
        this.retrieveCharOnetData({
          jobs_ids: [...listOfIds].map(job => job.id),
          date: [timeRange],
        })
          .then(() => {
            this.isLoading = false;
            this.key += 1;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
  },
  watch: {
    selectedEmployer(newSelectedEmployer) {
      this.localStoragePlugin.set('chartOneEmployerSelect', newSelectedEmployer);
    },
    jobFilterDataModel(newSelectedJob) {
      this.localStoragePlugin.set('chartOneJobSelect', JSON.stringify(newSelectedJob));
    },
    timeRangeDataModel(newSelectedTimeRange) {
      this.localStoragePlugin.set('chartOneTimeRangeSelect', newSelectedTimeRange);
    },
  },

  computed: {
    ...mapGetters(['getEmployersDropdown', 'getChartOneData']),
  },
  mounted() {
    if (this.localStoragePlugin.has('chartOneEmployerSelect')) {
      this.selectedEmployer = this.localStoragePlugin.get('chartOneEmployerSelect');
    } else {
      this.localStoragePlugin.set('chartOneEmployerSelect', JSON.stringify(this.selectedEmployer));
    }

    if (this.localStoragePlugin.has('chartOneJobSelect')) {
      this.jobFilterDataModel = this.localStoragePlugin.get('chartOneJobSelect');
    }

    if (this.localStoragePlugin.has('chartOneTimeRangeSelect')) {
      this.timeRangeDataModel = this.localStoragePlugin.get('chartOneTimeRangeSelect');
    }

    if (this.selectedEmployer.name !== 'Employer') {
      this.retrieveJobsForEmployerDropdown({ employerId: this.selectedEmployer.id })
        .then(response => {
          this.jobsForEmployerOptions = response.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }

    this.retrieveCharOnetData({
      jobs_ids: [...this.jobFilterDataModel.map(j => j.id)],
      date: [this.timeRangeDataModel.value],
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.funnel-filter {
  display: flex;
  padding: 12px;
  justify-content: space-between;
  .form-group {
    width: 33%;
    flex-shrink: 0;
    .form-control {
      width: 100%;
      display: block;
    }
  }
}
/* 
.multi-level {
  font-size: 144px;
  font-family: $font-family-sans-lato;
  color: #495057;
  li {
    padding: 0;
    a {
      padding: 6px 20px;
    }
  }
} */
</style>
